<template>
  <el-card class="page-container">
    <h1 class="title-biaoti">获取有效通话来源报表</h1>
    <el-row :gutter="20" class="user-options">
      <el-col :span="10">
        <el-date-picker
          v-model="platformData"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="retainedOptions"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-col>
      <el-col :span="6">
        <el-button type="warning" @click="getDayChatDetai" :loading="login1">
          查询
        </el-button>
        <el-button type="success" @click="dwnDayChatDetai" :loading="login2">
          下载
        </el-button>
      </el-col>
    </el-row>
    <el-row class="user-options">
      <el-table
        :data="dayChatDetailData"
        style="width: 100%"
        v-loading="login1"
        stripe
        border
      >
        <el-table-column prop="date" fixed label="日期" width="180">
        </el-table-column>
        <el-table-column prop="dau" fixed label="有效DAU" width="180">
        </el-table-column>
        <el-table-column prop="exposeCount" label="曝光总次数" width="180">
        </el-table-column>
        <el-table-column
          prop="activeExposeCount"
          label="有效曝光次数"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="listCallCount"
          label="列表按钮拨打次数"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="listCallOkCount"
          label="列表按钮拨打成功数"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="listCallOkRate"
          label="列表按钮拨打成功率"
          width="180"
        >
        </el-table-column>

        <el-table-column
          prop="detailCallCount"
          label="个人资料页拨打数"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="detailCallOkCount"
          label="个人资料页成功拨打数"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="detailCallOkRate"
          label="个人资料页成功拨打率"
          width="180"
        >
        </el-table-column>

        <el-table-column
          prop="followCallCount"
          label="follow进入资料页拨打数"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="nearByCallCount"
          label="NearBy列表点击拨打数"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="popupCallCount"
          label="推荐弹窗拨打数"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="showCallCount"
          label="show页面拨打数"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="textChatCallCount"
          label="文字聊天页面拨打数"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="textChatCallOkCount"
          label="文字聊天页拨打成功数"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="textChatCallOkRate"
          label="文字聊天页拨打成功率"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="videoDetailCallCount"
          label="视频资料页拨打数"
          width="180"
        >
        </el-table-column>

        <el-table-column
          prop="hostHomeExposeCount"
          label="资料页曝光次数"
          width="180"
        >
        </el-table-column>

        <el-table-column prop="conversionRate" label="转化率" width="180">
        </el-table-column>
        <el-table-column
          prop="hostHomeCallCount"
          label="资料页拨打次数"
          width="180"
        >
        </el-table-column>
        <el-table-column prop="homeCallRate" label="资料页拨打率" width="180">
        </el-table-column>
        <el-table-column prop="chatOkCount" label="总接通次数" width="180">
        </el-table-column>
        <el-table-column prop="chatOkRate" label="接通率" width="180">
        </el-table-column>

        <el-table-column prop="chatTime" label="总通话时长-s" width="180">
        </el-table-column>
        <el-table-column prop="avgChatTime" label="平均通话时长-s" width="180">
        </el-table-column>
        <el-table-column prop="chatGold" label="通话金币收入" width="180">
        </el-table-column
        ><el-table-column prop="giftGold" label="礼物金币收入" width="180">
        </el-table-column
        ><el-table-column prop="totalGold" label="总收入" width="180">
        </el-table-column>
        <el-table-column
          prop="hundredExposeGold"
          label="每百次曝光收入"
          width="180"
        >
        </el-table-column>
      </el-table>
    </el-row>
    <el-row class="user-options">
      <el-pagination
        :current-page.sync="page"
        layout="total, prev, pager, next"
        background
        @current-change="handleCurrentChange"
        :total="total"
        class="pagination"
      ></el-pagination>
    </el-row>
  </el-card>
</template>

<script>
import download from '@/utils/download.js'
import { datainfor } from '@/utils/formdata.js'
export default {
  data() {
    return {
      // 加载
      login1: false,
      login2: false,
      // 用户id白名单 MultipartFile文件
      ridFile: '',
      // 代理名或者代理id
      agentName: '',
      // 通话日期
      platformData: [datainfor(1), datainfor(1)],
      retainedOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      },
      // 分引
      page: 1,
      total: 0,
      // 表格数据
      dayChatDetailData: []
    }
  },
  created() {
    this.getDayChatDetai()
  },
  methods: {
    // 查询列表
    async getDayChatDetai() {
      this.login1 = true

      const { data: res } = await this.$axios({
        type: 'GET',
        url: this.$store.getters.path.active_source,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          start: this.platformData[0],
          end: this.platformData[1],
          page: this.page
        }
      })
      this.login1 = false
      if (res.code != 0) return this.$message(res.msg)
      this.dayChatDetailData = res.data.data
      this.total = res.data.total
    },
    // 下载
    async dwnDayChatDetai() {
      this.login2 = true
      const res = await this.$axios({
        method: 'GET',
        url: this.$store.getters.path.download_active_source,
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'blob',
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          start: this.platformData[0],
          end: this.platformData[1]
        }
      })

      this.$message.success('开始下载')
      this.login2 = false
      download(res.data, '获取有效通话来源报表' + this.platformData[1])
    },
    // 分页
    handleCurrentChange() {
      this.getDayChatDetai()
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../../assets/stylus/variable.styl';

.page-container {
  margin-left: 20px;
  margin-top: 20px;

  h1 {
    font-size: 28px;
    font-weight: bold;
  }

  .user-options {
    margin-top: 40px;

    button {
      margin-left: 30px;
    }
  }

  .display-type {
    margin-top: 20px;

    .line {
      width: 1440px;
      height: 700px;
    }
  }
}
</style>
